import type { SVGProp } from './types';

export const chevronDown = (props: SVGProp) => (
  <svg
    width={props.width || '24'}
    height={props.height || '24'}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    {...props}
  >
    <path
      d="m12.7524 15.5515 5.65-5.66004c.0938-.09297.1682-.20357.2189-.32543.0508-.12186.0769-.25256.0769-.38457 0-.13202-.0261-.26272-.0769-.38458-.0507-.12186-.1251-.23246-.2189-.32542-.1873-.18625-.4408-.2908-.705-.2908-.2641 0-.5176.10455-.705.2908l-5 4.95004-4.94996-4.95004c-.18736-.18625-.44081-.2908-.705-.2908-.26418 0-.51763.10455-.705.2908-.09448.09261-.16965.20306-.22115.32493-.0515.12188-.0783.25276-.07884.38507.00054.1323.02734.26319.07884.38506.0515.12188.12667.23232.22115.32494l5.64996 5.66004c.0937.1015.2073.1825.3338.2379.1265.0554.2631.084.4012.084.1381 0 .2748-.0286.4012-.084.1265-.0554.2402-.1364.3338-.2379Z"
      fill="currentColor"
    />
  </svg>
);
